/*
 * newsbot - Stacked favicon images for story source domains
 */

import { Tooltip } from "@components/tooltips/Tooltip";
import { getFaviconUrl } from "@utils/favicon";

interface SourceFaviconsProps {
  domains: string[];
}

export const SourceFavicons = ({ domains }: SourceFaviconsProps) => {
  if (!domains || domains.length === 0) {
    return <span className="text-gray-400 dark:text-gray-500 text-xs">-</span>;
  }

  const displayDomains = domains.slice(0, 3);

  const tooltipContent = (
    <div className="flex flex-col gap-1">
      {domains.map((domain) => (
        <span key={domain} className="text-xs">{domain}</span>
      ))}
    </div>
  );

  return (
    <Tooltip label={
      <div className="flex items-center gap-1.5">
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {domains.length}
        </span>
        {displayDomains.map((domain) => (
          <img
            key={domain}
            src={getFaviconUrl(domain)}
            alt={domain}
            title={domain}
            className="w-4 h-4"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        ))}
      </div>
    }>
      {tooltipContent}
    </Tooltip>
  );
};
